<template>
  <div class="confirm-container">
    <!-- <asset-header></asset-header> -->
    <div class="confirm-wrap">
      <div class="title">
        {{ "출금 내역 확인" }}
      </div>
      <div v-if="Server.version == 3" class="keycolor fs12 mt10 mb20">
        ※ 트래블룰 솔루션 연동 지연에 따라 2022. 03. 25 00시부터 100만원 이상의
        출금은 불가합니다.
      </div>
      <div class="content">
        <ul>
          <li flex fjb>
            <p class="name">{{ "출금금액" }}</p>
            <p class="detail ta-r">
              <span class="bold">{{ getWithdrawalData.amount }}</span>
              {{ activeCoin.code }}
            </p>
          </li>
          <li flex fjb>
            <p class="name">{{ "수수료" }}</p>
            <p v-if="$route.query.local == 'true'">0 {{ activeCoin.code }}</p>
            <p v-else class="detail ta-r">
              {{ getWithdrawalData.fee }}
              {{ activeCoin.code }}
            </p>
          </li>
          <li>
            <p class="name">{{ "출금주소" }}</p>
            <p class="detail ta-r fs12">
              {{ getWithdrawalData.toAddress }}
            </p>
          </li>
          <li>
            <p class="name">{{ "총 출금수량(수수료 포함)" }}</p>
            <p class="detail ta-r">
              <span class="bold">{{ getWithdrawalData.finalWithdraw }}</span>
              {{ activeCoin.code }}
            </p>
          </li>
        </ul>
      </div>

      <!-- sms, otp 인증 -->
      <div class="auth">
        <div class="w12 auth-box mt10 pt10">
          <div class="w12" v-if="!useOTP">
            <div class="">
              {{ $t("mypage.bank.휴대폰 인증") }}
            </div>
            <div class="default mt4">
              <span class="gray">{{ $t("mypage.bank.휴대폰 번호") }}</span>
              {{ getWithdrawalData.phone }}
            </div>
            <button
              class="w12 black mt10 mb10 checkAddress"
              @click="sendAuthCode"
            >
              {{ $t("mypage.bank.인증번호 발송") }}
            </button>
            <div class="default mt10">
              인증번호 {{ send ? "재발송" : "발송" }}
            </div>
            <div class="w12 input-box" style="position: relative">
              <el-input
                class="w12 mt4"
                type="text"
                maxlength="6"
                pattern="[0-9]*"
                inputmode="decimal"
                v-model="authCode"
                :placeholder="$t(`notice.content.enterVerificaiton`)"
              />
              <div class="timer roboto">
                {{ isSendCode ? remain : "00:00" }}
              </div>
            </div>
            <div class="default mt10 fs12">
              {{ $t("mypage.bank.주의사항[0]") }}
              <br />
              {{ $t("mypage.bank.주의사항[1]") }}
            </div>
          </div>
          <div v-else class="w12">
            <div>
              {{ $t("mypage.verify.OTPVerificaiton") }}
            </div>
            <div class="w12 input-box">
              <el-input
                class="w12 mt4"
                type="text"
                maxlength="6"
                pattern="[0-9]*"
                inputmode="decimal"
                v-model="authCode"
                :placeholder="$t(`notice.content.enterVerificaiton`)"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- // sms, otp 인증 -->

      <!-- 출금하기 버튼 -->
      <div class="w12 mt11">
        <!-- 출금하기 버튼: KRW일 때 분기 -->
        <div v-if="activeCoin.code == 'KRW'">
          <button @click="withdraw()" class="withdraw-button">
            {{ $t("withdraw.withdrawal") }}
          </button>
        </div>
        <!-- 출금하기 버튼: 가상자산일 때 분기 -->
        <div v-else>
          <button
            :disabled="disabledWithdraw"
            @click="withdraw()"
            class="withdraw-button"
          >
            {{ $t("withdraw.withdrawal") }}
          </button>
        </div>
      </div>
      <!-- // 출금하기 버튼 -->

      <!-- 이용안내 -->
      <div class="noti-box mt20">
        <div class="noti-title mb6">
          {{ $t("withdraw.informationToUse") }}
        </div>
        <ul>
          <li>{{ $t("withdraw.info[2]") }}</li>
          <li>{{ $t("withdraw.description") }}</li>
          <li v-show="activeCoin.code !== 'KRW'" class="w12">
            {{ $t("withdraw.confirmAddress") }}
          </li>
          <li v-show="activeCoin.code !== 'KRW'" class="w12">
            {{ $t("withdraw.enterWrongDeposit") }}
          </li>
          <li
            v-show="activeCoin.code !== 'KRW'"
            class="w12"
            v-html="$t('withdraw.recovery')"
          ></li>
        </ul>
      </div>
      <!-- // 이용안내 -->

      <!-- 주의사항 -->
      <div class="noti-box mt20">
        <div class="noti-title mb7" flex fic>
          <img src="../../../assets/img/icon/ico_exclamation.png" class="mr4" />
          {{ $t("withdraw.precautions.name") }}
        </div>
        <ul class="w12 pl18 no-dot">
          <!-- <li class="w12">
            {{ $t("withdraw.precautions.identityVerification") }}
              </li>-->
          <li class="w12">{{ $t("withdraw.precautions.after3Days") }}</li>
          <li class="w12">{{ $t("withdraw.precautions.severalDays") }}</li>
          <template v-if="activeCoin.code === 'AMPL'">
            <li class="w12 keycolor">
              AMPL 토큰은 리베이스 시간에는 출금이 제한됩니다.
            </li>
            <li class="w12 keycolor">
              리베이스 시간에는 출금 신청이 되지 않으며, 기존 출금건으 취소될 수
              있으니 출금시 유의하시기 시간여유를 가지고 출금 신청 부탁드립니다.
            </li>
          </template>
        </ul>
      </div>
      <!-- // 주의사항 -->
    </div>

    <!-- 출금불가 -->
    <el-dialog
      title="출금 실패"
      :visible.sync="withdrawFailModal"
      :show-close="false"
      class="modal-type01 popup modal-small"
      center
    >
      <div class="text-center">
        <p class="text-type02" v-html="withdrawResult.msg"></p>
      </div>
      <div slot="footer" class="dialog-footer">
        <button class="cancel" @click.prevent="withdrawFailModal = false">
          {{ $t("confirm.close") }}
        </button>
      </div>
    </el-dialog>
    <!-- //출금불가 -->

    <!-- 출금완료 -->
    <el-dialog
      :title="$t(`notice.title.withdrawalRequestComplete`)"
      :visible.sync="withdrawSuccessModal"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="modal-type01 popup"
      center
    >
      <div class="text-left">
        <p class="text-type01">{{ $t("withdraw.description") }}</p>
        <ul class="modal-list" style="list-style:none;">
          <li>
            <div class="mr10">{{ $t("withdraw.출금계좌 주소") }}</div>
            <div class>{{ withdrawResult.toAddress }}</div>
          </li>
          <li class="mt10">
            <div class="mr10">
              {{ $t("withdraw.출금") }} {{ activeCoin.code }}
            </div>
            <div class>
              {{ withdrawResult.finalAmount }} {{ activeCoin.code }}
            </div>
          </li>
        </ul>
      </div>
      <div slot="footer" class="dialog-footer">
        <span @click="withdrawSuccessModal = false">
          <router-link
            :to="`/balances/log/${activeCoin.code}`"
            tag="button"
            class="btn-style01"
            >{{ $t("confirm.ok") }}</router-link
          >
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// component
import Moment from "moment";

import AssetHeader from "../component/asset/header";
// vuex
import { mapState, mapGetters } from "vuex";
// 라이브러리
import Api from "@/common/Api";
import Decimal from "decimal.js";

export default {
  components: {
    AssetHeader,
  },
  created() {
    setInterval(this.remainTime, 1000);

    if (!_.has(this.$route.params, "coinId")) {
      this.$router.back();
      return false;
    }

    this.getWithdrawalData = this.$route.params;
    this.activeCoin = this.$route.params.activeCoin;
    // this.needAddressee = this.$route.params.needAddressee;
    this.tag = this.$route.params.toParam ? this.$route.params.toParam.tag : "";
  },
  data() {
    return {
      getWithdrawalData: {},
      activeCoin: {},
      phone: "",
      authCode: "",
      authToken: "",
      expire: +Moment().add(3, "minutes"),
      isSendCode: false,
      withdrawSuccessModal: false,
      withdrawFailModal: false,
      withdrawResult: {},
      tag: "",
      verificationUuid: "",
      // needAddressee: false,
      remain: "00:00",
      local: "",
    };
  },
  computed: {
    ...mapState(["Server"]),
    ...mapGetters(["useOTP"]),
    disabledWithdraw() {
      if (this.authCode.length !== 6) {
        return true;
      }
    },
  },
  methods: {
    sendAuthCode() {
      Api.User.sendSMS({
        token: this.$route.params.token,
      }).then((response) => {
        this.expire = +Moment().add(3, "minutes");
        this.remainTime();
        this.isSendCode = true;
        this.authToken = _.get(response, ["body", "requestCode"]);
      });
    },
    remainTime() {
      const remain = Moment(+this.expire - +Moment());
      if (+remain > 0) {
        this.remain = remain.format("mm:ss");
      } else {
        this.remain = "00:00";
      }
    },
    async withdraw() {
      // opt 인증번호 입력하지 않았을 때
      if (this.useOTP && this.authCode.length == 0) {
        this.$vs.notify({
          title: this.$t("notice.title.error"),
          text: "OTP 인증번호를 입력해 주세요",
          position: "top-left",
          color: "danger",
        });
        return false;
      }

      const params = {
        coinId: this.activeCoin.id,
        amount: this.getWithdrawalData.amount,
        toAddress: this.getWithdrawalData.toAddress,
        transferType: "O",
        authType: this.useOTP ? "OTP" : "SMS",
        authValue: this.authCode,
        seToken: this.getWithdrawalData.seToken,
        local: this.$route.query.local,
      };

      if (!this.useOTP) {
        params.authToken = this.authToken;
      }

      if (this.tag) {
        params.toParam = this.tag;
      }

      const error = (e) => {
        const msg = _.get(e, "msg", "서버오류");
        const { code, message } = _.get(e, ["response", "data", "header"]);
        if (_.get(e, "code") === 4100) {
          // 블랙리스트라 그냥 전역단계에서 처리하도록 둔다
          return e;
        }
        if (_.get(e, "code") === 5100) {
          // GlobalEvent.modal({ modalName: "needVerification", show: true });
          this.needVerification = true;
          return true;
        }
        if (code === 4052) {
          this.CertificationModal.show = true;
          this.CertificationModal.num = message;
          return false;
        }
        if (code == "7100") {
          this.withdrawResult.msg = `은행전산시스템 점검으로 인하여<br><strong class="txt-blue">${message} 까지</strong><br>플라이빗에서 입금 서비스 이용이 제한됩니다.`;
          this.withdrawFailModal = true;
          return false;
        }
        this.withdrawResult = {
          ...e,
          msg,
        };
        this.withdrawFailModal = true;
      };

      if (this.activeCoin.code === "KRW") {
        params.mode = "withdraw";
        params.backCode = "280";
        params.deviceType = 200;

        try {
          const response = await Api.Transfer.transferKRW(params);

          this.withdrawResult = response.body;
          this.withdrawResult.toAddress = this.accounts.deposit.accountNumber;
          this.withdrawResult.finalAmount = Decimal(response.body.amount)
            .add(response.body.fee)
            .toNumber();
          this.withdrawSuccessModal = true;
          this.$gtm.trackEvent({
            event: "ga_withdrawal",
            label: `${this.activeCoin.code} | ${Decimal(response.body.amount)}`,
          });
        } catch (error) {
          console.log(error);
          this.$msgbox({
            message: error.msg,
            type: "default",
          });
          return;
        }
      } else {
        try {
          const response = await Api.Transfer.transferAsset(params);
          this.withdrawResult = response.body;
          this.withdrawResult.finalAmount = Decimal(response.body.amount)
            .add(response.body.fee)
            .toNumber();
          this.withdrawSuccessModal = true;
          this.$gtm.trackEvent({
            event: "ga_withdrawal",
            label: `${this.activeCoin.code} | ${Decimal(response.body.amount)}`,
          });
        } catch (error) {
          console.log(error);
          this.$msgbox({
            message: error.msg,
            type: "default",
          });
          return;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  margin-bottom: 0;
  word-break: break-all;
}
input {
  font-size: 14px;
  padding: 5px;
}
button.withdraw-button {
  width: 100%;
  padding: 10px;
}
.confirm-wrap {
  padding: 20px 12px;
  font-size: 14px;
  .content {
    padding: 10px;
    margin-top: 10px;
    background-color: #f7f8fa;
    ul {
      list-style: none;
      li {
        margin-bottom: 10px;
        &.align {
          display: flex;
          justify-content: space-between;
        }
        &:last-of-type {
          margin-bottom: 0;
          .detail {
            font-size: 16px;
            color: #eb3246;
          }
        }
      }
    }
  }
}
.noti-wrap {
  list-style: none;
  li {
    &:before {
      width: 4px;
      height: 4px;
      border-radius: 5px;
      background-color: #222;
    }
  }
}
/* 트래블룰 검증 */
.travelRule-wrap {
  padding-top: 20px;
  margin-top: 20px;
  border-top: 1px solid #eef0f3;
  border-bottom: 1px solid #eef0f3;
  font-size: 14px;
  .noti {
    margin: 0 0 15px;
  }
}
.checkAddress {
  width: 100%;
  padding: 10px;
  margin: 20px 0 28px;
  font-size: 14px;
  border-radius: 3px;
  background-color: #222;
}
</style>
